module.exports = __webpack_public_path__ + "img/family.e6a702be.png";